var React = require('react');

function BottomCurveGray (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 83C454.33-24.774 928.696-27.898 1384.99 71.96L1440 83v2H0Z","fill":"#F6FAFF"}));
}

BottomCurveGray.defaultProps = {"className":"curve-section-shape","width":"1440","height":"124","viewBox":"0 0 1440 84","fill":"none","preserveAspectRatio":"none"};

module.exports = BottomCurveGray;

BottomCurveGray.default = BottomCurveGray;
